<h2 class="first_title">Amministrazione</h2>
<div export-help></div>
<div class="content-page-wrapper">
  <div class="standardpanel">
  
    <div class="panel-group">
      <div class="panel panel-default">
        <div class="panel-heading">
          <div class="row">
            <h2 class="panel-title col-xs-10">
              <a data-toggle="collapse" href="#collapse1">Ricerca</a>
            </h2>
            <div class="col-xs-2">
              <a data-toggle="collapse" href="#collapse1" aria-expanded="false">
                <span (click)="onLoadData()" class="glyphicon glyphicon-triangle-bottom"></span>
                <span class="glyphicon glyphicon-triangle-top"></span>
              </a>
            </div>
          </div>
        </div>
        <div id="collapse1" class="panel-collapse collapse">
          <div class="panel-body"><app-dynamic-form [questions]="formFields" [config]="formConfiguration"
              (onFormSubmit)="onSearch($event)"></app-dynamic-form></div>
        </div>
      </div>
    </div>
  
  
    <div class="titleblock">
      <h3 class="title1level">
        Gestione Società
      </h3>
      <p>
        <a (click)="addCompanies()" href="javascript:void(0)">
          Aggiungi Società
          <span class="glyphicon glyphicon-plus-sign"></span>
        </a>
      </p>
    </div>
    <div class="titleblock">
      <h3 class="title1level" style="padding: 25px 0px 0px 0px"></h3>
      <p style="margin-top: -20px">
        <a (click)="onRefresh()" href="javascript:void(0)">
          Aggiorna
          <span style="margin-left: 10px;" class="glyphicon glyphicon-refresh"></span>
        </a>
      </p>
    </div>
  
    <div class="container_dati_generali">
      <app-societa-list *ngIf="formFields"
        (deleteCompany)="onDeleteCompany($event)"
        (editCompany)="onEditCompany($event)"
        [companyList]="companyList != undefined ? companyList.items : []">
      </app-societa-list>
      <div class="card-pagination">
        <app-pagination
          [resetCurrentPage]="resetCurrentPage"
          [totalItems]="companyList != undefined ? companyList.totalItems : 0"
          [hasAutoRefresh]="true"
          (refreshEvent)="onRefresh($event)">
        </app-pagination>
  
      </div>
    </div>
  </div>
</div>
